import { addMoveRecapElements, injectRecapImages } from "./cart";

export function initStep2() {
    if ($('.id--16').length) {
        moveAddStep2Elements()
        step2TextChanges()
        injectRecapImages()
        addMoveRecapElements()
    }
}

function moveAddStep2Elements() {
    $(`<h4>Versand und Zahlung</h4>`).insertBefore('.cart-content');
}

function step2TextChanges() {
    $('.btn-conversion.next-step-forward').text('Ihre Daten');
    $('.btn.next-step-back').text('Einen Schritt zurück');
}

